import React from 'react'
import { LuArrowLeftRight, LuArrowRight } from 'react-icons/lu'
import { useNavigate } from 'react-router'

import SearchResultIcon from '@/components/misc/GlobalSearch/components/SearchResultIcon'
import SearchResultItem from '@/components/misc/GlobalSearch/components/SearchResultItem'
import { SEARCH_RESULT_ICON_COLORS } from '@/components/misc/GlobalSearch/constants'
import { useGlobalSearch } from '@/components/misc/GlobalSearch/hooks/useGlobalSearch'
import { Badge } from '@/components/ui/badge'
import { CommandGroup } from '@/components/ui/command'
import { DATE_FORMATS } from '@/lib/constants'
import { formatDate } from '@/lib/helpers/dateHelpers'
import { ROUTES } from '@/lib/routes'
import { ReferralSearchResult } from '@/types/responses/companies'

interface Props {
  referrals: ReferralSearchResult[]
}

const ReferralResults: React.FC<Props> = ({ referrals }) => {
  const globalSearch = useGlobalSearch()
  const navigate = useNavigate()

  if (referrals.length === 0) {
    return null
  }

  return (
    <CommandGroup heading="Referrals">
      {referrals.map((referral, index) => (
        <SearchResultItem
          key={referral.id}
          index={index}
          value={`referral-${referral.id}`}
          className="flex items-start gap-3"
          onSelect={() => {
            globalSearch.hide()
            navigate(
              ROUTES.referralSummary({
                params: { referralId: referral.id.toString() },
              }),
            )
          }}
        >
          <SearchResultIcon
            icon={LuArrowLeftRight}
            color={SEARCH_RESULT_ICON_COLORS.blue}
          />

          {/* text */}
          <div className="flex flex-1 flex-col gap-0 items-stretch">
            <div className="flex gap-1 items-end justify-between">
              <span className="font-medium">{referral.client.fullName}</span>

              <span className="text-muted-foreground text-xs">
                #{referral.id}
              </span>
            </div>

            <div className="text-muted-foreground text-xs">
              {referral.client.email}
            </div>

            <div
              className="text-muted-foreground flex flex-col gap-0.75 text-xs"
            >
              <div className="flex justify-between">
                <div className="flex flex-wrap items-center gap-1">
                  {referral.fromCompanyNameOrAdviserEmail}
                  <LuArrowRight className="size-2.5" />
                  {referral.toCompanyNameOrAdviserEmail}
                </div>

                <div>
                  {formatDate(
                    referral.referralDate,
                    DATE_FORMATS.DAY_MONTH_YEAR,
                  )}
                </div>
              </div>

              {referral.serviceAreaNames.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {referral.serviceAreaNames.map((serviceArea, i) => (
                    <>
                      <Badge
                        key={serviceArea}
                        variant="primary-light"
                        size="sm"
                        // className="text-muted"
                      >
                        {serviceArea}
                      </Badge>

                      {i < referral.serviceAreaNames.length - 1 && (
                        <span className="text-muted-foreground">⋅</span>
                      )}
                    </>
                  ))}
                </div>
              )}
            </div>
          </div>
        </SearchResultItem>
      ))}
    </CommandGroup>
  )
}

export default ReferralResults
